import React from "react";
import PageHero from "../components/ui-custom/PageHero";
import Reveal from "../components/ui-custom/Reveal";
import { milestones } from "../data/mock";

const Milestones = () => {
  return (
    <div>
      <PageHero
        eyebrow="Corporate / Milestones"
        title="Our Journey"
        subtitle="Two decades of growth — from incorporation to international acquisitions and a successful public listing."
      />
      <section className="px-6 pb-28">
        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-qcyan/60 via-qcyan/20 to-transparent" />
          <div className="space-y-10">
            {milestones.map((m, i) => (
              <Reveal key={m.year} delay={i * 0.06}>
                <div className="relative pl-12 md:pl-14">
                  <span className="absolute left-0 top-1 w-8 h-8 rounded-full glass-panel flex items-center justify-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-qcyan shadow-[0_0_10px_rgba(255, 0, 15,0.8)]" />
                  </span>
                  <div className="font-display font-bold text-2xl glow-text-cyan mb-1">{m.year}</div>
                  <h3 className="text-foreground font-semibold text-lg mb-1">{m.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{m.detail}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Milestones;
